import React, { memo } from 'react';
import LayerStatisticsBarGroup from './LayerStatisticsBarGroup';
import Box from '@mui/material/Box';
import Styles from './LayerStatisticsBarChart.module.less';
import type { LayerStatisticsItem } from '../sources/LayerStatisticsSourceTypes';

type LayerStatisticsBarChartProps = {
  items: LayerStatisticsItem[];
  width: number;
};

const LayerStatisticsBarChart = ({ items, width }: LayerStatisticsBarChartProps) => {
  const barHeight = 25;

  const barGroups = items.map((d, i) => (
    <Box key={i} transform={`translate(0, ${i * barHeight})`}>
      <LayerStatisticsBarGroup entry={d} barHeight={barHeight} width={width} />
    </Box>
  ));

  return <Box className={Styles.container}>{barGroups}</Box>;
};

export default memo(LayerStatisticsBarChart);
